import { useSettings } from '@/data/Settings';
import { setCookieCAPI } from 'presentation/events/utils/eventCookieUtils';
import { useCallback } from 'react';
import { useTrackSearchSubmitFacebook } from './useTrackSearchSubmitFacebook';
import { useTrackSearchSubmitGA4 } from './useTrackSearchSubmitGA4';
import { useTrackSearchSubmitPinterest } from './useTrackSearchSubmitPinterest';
import { useTrackSearchSubmitTikTok } from './useTrackSearchSubmitTikTok';

export const useTrackSearchSubmit = () => {
	const { settings } = useSettings();
	const { storeId } = settings;

	const { sendGA4Event } = useTrackSearchSubmitGA4();
	const { sendFacebookEvent } = useTrackSearchSubmitFacebook();
	const { sendPinterestEvent } = useTrackSearchSubmitPinterest();
	const { sendTiktokEvent } = useTrackSearchSubmitTikTok();

	const sendSocialMediaEvents = useCallback(
		({ searchTerm }: { searchTerm: string }) => {
			const eventId = setCookieCAPI('mfbt');

			sendFacebookEvent({ searchTerm, eventId, storeId });
			sendPinterestEvent({ searchTerm, eventId, storeId });
			sendTiktokEvent({ searchTerm, eventId, storeId });
		},
		[sendFacebookEvent, sendPinterestEvent, sendTiktokEvent, storeId]
	);

	return { sendGA4Event, sendSocialMediaEvents };
};
